import type { ReactNode } from 'react';

import { DEVICE_WIDTHS } from '@/types/feedback';

import { CANVAS_FRAME_HEIGHT } from './canvasConstants';

import type { DevicePreset } from '@/types/feedback';

interface CanvasDeviceFrameProps {
  device: DevicePreset;
  scale: number;
  label: string;
  children: ReactNode;
}

export function CanvasDeviceFrame({
  device,
  scale,
  label,
  children,
}: CanvasDeviceFrameProps) {
  const nativeWidth = DEVICE_WIDTHS[device];

  return (
    <div className="flex flex-col items-center">
      <div className="mb-3 text-xs font-medium text-muted-foreground">
        {label}
      </div>
      <div
        style={{
          width: nativeWidth * scale,
          height: CANVAS_FRAME_HEIGHT * scale,
          backgroundColor: '#fff',
          overflow: 'hidden',
          borderRadius: 12,
          boxShadow:
            '0 4px 6px -1px rgba(0,0,0,0.08), 0 12px 32px -4px rgba(0,0,0,0.12)',
        }}
      >
        <div
          style={{
            width: nativeWidth,
            height: CANVAS_FRAME_HEIGHT,
            transformOrigin: 'top left',
            transform: `scale(${scale})`,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
